import React from 'react';

import Button from '../common/Button/Button';
import Label from '../common/Labels/Label';

import { getThemeColor } from '../../utils/theme-utils';

export const FilterCountButton = ({ activeFilters = 0, onClick = () => {}, disabled = false }) => (
  <Button className="mx-2" variant="brand" onClick={onClick} disabled={disabled}>
    <div className="py-0.5 flex items-center justify-between">
      <Label className="align-middle" color={getThemeColor('background')}>
        { activeFilters > 0 ? 'Filtered' : 'Filter' }
      </Label>
      { activeFilters > 0 && (
        <Label className="ml-2 px-1.5 py-0.25 rounded-full bg-background align-middle">{activeFilters}</Label>
      )}
    </div>
  </Button>
)

export default FilterCountButton;
